import { useQuery, AnyQueryKey } from 'react-query'
import { useSelector } from 'react-redux'
import { superFetch } from 'commons'
import { getReady } from 'store/api'
import { getContractId } from 'store/selection'
import { getUorIdMst } from 'store/oidc'

const ONE_DAY = 86400000

export const isUor = (node: TreeNode): node is Uor => (node as Uor).UorNom !== undefined

export const useOrganisationAll = () => {
  const ready = useSelector(getReady)

  const { data } = useQuery<Organisation, AnyQueryKey>(
    ready && ['organisation'],
    () => superFetch({ url: `organisation` }),
    { staleTime: ONE_DAY },
  )

  return data
}

export const useOrganisation = () => {
  const ready = useSelector(getReady)
  const contractId = useSelector(getContractId)

  const { data } = useQuery<Organisation, AnyQueryKey>(
    ready && contractId !== null && ['organisation', { contractId }],
    () => superFetch({ url: `organisation?contratId=${contractId}` }),
    { staleTime: ONE_DAY },
  )

  return data
}

export const useOrganisationUsers = () => {
  const ready = useSelector(getReady)
  const uorId = useSelector(getUorIdMst)

  const { data } = useQuery<OrganisationUser[], AnyQueryKey>(
    ready && uorId !== null && ['organisationUsers', { uorId }],
    () => superFetch({ url: `utilisateurs/organisation/${uorId}` }),
    { staleTime: ONE_DAY },
  )

  return data
}

/**
 * Retrieve KAM(admin) users for a specific organisation
 */
export const useOrganisationKAMUsers = () => {
  const ready = useSelector(getReady)
  const uorId = useSelector(getUorIdMst)

  const { data } = useQuery<OrganisationUser[], AnyQueryKey>(
    ready && uorId !== null && ['organisationUsers', { uorId }],
    () => superFetch({ url: `utilisateurs/organisation/${uorId}/admins` }),
    { staleTime: ONE_DAY },
  )

  return data
}
